<script setup lang="ts">
/**
 * App.vue — thin top-level shell selector.
 * Resolves to AppLayout (authenticated routes) or LoginView (public, top-level) —
 * see router/index.ts. No layout logic lives here.
 *
 * UpdateBanner is mounted once here (not per-view) so a waiting PWA update
 * is reachable from every screen, including LoginView — see its own header
 * comment / main.ts for why this exists.
 *
 * InstallBanner is mounted the same way and for the same reason (an install
 * prompt is just as relevant on LoginView as anywhere else). It also renders
 * fixed to the BOTTOM (not the top — every authenticated screen has a
 * sticky topbar a top-fixed banner would cover) and shifts up by
 * UpdateBanner's height when that one is also visible, so the two stack
 * instead of overlapping.
 */
import UpdateBanner from './components/UpdateBanner.vue';
import InstallBanner from './components/InstallBanner.vue';
</script>

<template>
  <router-view />
  <UpdateBanner />
  <InstallBanner />
</template>
